import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()

  // Wait for the mount-time session check (AuthContext.checkSession) before
  // deciding to redirect. Without this, a page reload would always redirect
  // to /login: isAuthenticated starts false on every fresh page load (there
  // is no synchronous way to know a cookie exists) and the check that
  // confirms the httpOnly cookie-based session hasn't resolved yet.
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-muted-foreground text-sm">Loading…</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
